import { render, staticRenderFns } from "./DatepickerRtl.vue?vue&type=template&id=368054dc&"
import script from "./DatepickerRtl.vue?vue&type=script&lang=js&"
export * from "./DatepickerRtl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports